import React,{useState,useEffect} from 'react';
import axios from './axios';

import "./Row.css";
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer';

const baseUrl="https://image.tmdb.org/t/p/original/"
function Row({title,fetchUrl,isLargeRow}){

const [movies,setMovies]=useState([])
const [trailerUrl,setTrailerUrl]=useState(""); 			

// A snippet of code which runs based on a specific condition
// if [], useEffect just run once
// if [movies], useEffect runs every time movies changes 
useEffect(()=>{
	async function fetchData(){
		const request=await axios.get(fetchUrl);
		setMovies(request.data.results)
		return request;
	}
	fetchData();

},[fetchUrl])

const opts={
	height:"390",
	width:"100%",
	playerVars:{
		//https://developers.google.com/youtube/player_parameters
	    autoplay:1,
	}
}

const handleClick=(movie)=>{
	if(trailerUrl){
		setTrailerUrl('');
	}else{
		movieTrailer(movie?.name || "")
		.then((url)=>{
			//https://www.youtube.com/watch?v=XtMThy80KqU
		 const urlParams=new URLSearchParams(new URL(url).search);
		 setTrailerUrl(urlParams.get("v"));
		})
	  .catch(error=>console.log(error))
	}
}

// console.log(movies)
	return(
		<div className="row">
          <h2>{title}</h2>
          <div className="row__posters">
            {movies.map(movie=>(
            	<img
            	onClick={handleClick(movie)}
            	key={movie.id} 
            	className={`row__poster ${isLargeRow && "row__posterLarge"}`} 
            	src={`${baseUrl}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} 
            	alt={movie.name}/>
            ))}
          </div>
          {trailerUrl && <YouTube videoId="" opts={opts}/>}
		</div>
		)
};

export default Row;